"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineItemReferenceTransport = exports.InvoiceReferenceTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
exports.InvoiceReferenceTransport = typebox_1.Type.Object({
    entityType: common_1.EntityType,
    id: typebox_1.Type.String(),
});
exports.LineItemReferenceTransport = typebox_1.Type.Intersect([
    exports.InvoiceReferenceTransport,
    typebox_1.Type.Object({ entityData: typebox_1.Type.Optional(common_1.LineItemEntityData) }),
]);
//# sourceMappingURL=invoice-reference-transport.js.map